import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ConfigService } from '../../shared/services/config.service';
import { User } from '../../models';
import { environment } from '../../../environments/environment';
import { SettingsService } from '../../shared/services/settings.service';
import { NgSwitch, NgSwitchCase } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';

@Component({
    selector: 'stripe-setup',
    templateUrl: './stripe-setup.component.html',
    providers: [],
    standalone: true,
    imports: [FlexModule, NgSwitch, NgSwitchCase]
})
export class StripeSetupComponent implements OnInit {
  stripeUrl =
    'https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write';

  status: 'unknown' | 'connecting' | 'connected' | 'disconnected' = 'unknown';
  queryParams;

  constructor(
    private router: Router,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private settingsService: SettingsService
  ) {
    this.stripeUrl += `&client_id=${environment.stripe_client_id}`;
    this.queryParams = this.route.snapshot.queryParams;
    if (
      this.queryParams['integration'] &&
      this.queryParams['integration'] !== 'xero' &&
      'code' in this.queryParams &&
      'scope' in this.queryParams
    ) {
      this.status = 'connecting';
      this.connectAccount();
    } else {
      this.checkStatus();
    }
  }

  ngOnInit() {
    this.configService.currentUser.subscribe((user: User) => {
      if (user && user.email) {
        this.stripeUrl += `&stripe_user[email]=${user.email}`;
      }
    });
  }

  connectAccount() {
    this.settingsService
      .registerStripeConfiguration(this.queryParams)
      .subscribe(
        (result) => {
          this.status = 'connected';
        },
        (error) => {
          this.status = 'disconnected';
          throw error;
        }
      );
  }

  checkStatus() {
    this.settingsService.getStripeStatus().subscribe((result: any) => {
      if (result.connected === true) {
        this.status = 'connected';
      } else {
        this.status = 'disconnected';
      }
    });
  }
}
